import React from "react"
import Navbar from "../../../Common/Navbar"
import Footer from "../../../Common/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import EditTransactionComp  from "./Component/EditTransactionComp"

const EditTransaction =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <EditTransactionComp />
        </div>
        <Footer />
        </>
    )
}

export default EditTransaction